import { useEffect, useRef } from 'react'

import { deleteAIConversation, updateAIConversation } from '../../../../../api'
import { isApiNotFoundStatus } from '../../../../../utils/api'
import { GretaAIChatStatus } from '../../../GretaAIChat.constants'
import {
  getGretaAIChatChatsWithoutId,
  getHasGretaAIChatChatId,
  mapGretaAIChatChat,
} from '../useGretaAIChatChatListLoader.utils'

// Optimistic list edits, rolled back when the request fails.
export function useGretaAIChatChatMutations({
  chats,
  setChats,
  setChatsStatus,
}) {
  const chatsRef = useRef(chats)

  useEffect(() => {
    chatsRef.current = chats
  }, [chats])

  function addChat(chat) {
    const mappedChat = mapGretaAIChatChat(chat)

    setChats(current =>
      getHasGretaAIChatChatId(current, mappedChat.id)
        ? current
        : [mappedChat, ...current]
    )
    setChatsStatus(GretaAIChatStatus.Idle)
  }

  async function renameChat(id, title) {
    const previous = chatsRef.current

    setChats(current =>
      current.map(chat => (chat.id === id ? { ...chat, title } : chat))
    )

    try {
      await updateAIConversation({ data: { title }, id })

      return true
    } catch (reason) {
      if (isApiNotFoundStatus(reason?.response?.status)) {
        setChats(current => getGretaAIChatChatsWithoutId(current, id))

        return false
      }

      setChats(previous)

      throw reason
    }
  }

  function dropChat(id) {
    setChats(current => getGretaAIChatChatsWithoutId(current, id))
  }

  async function removeChat(id) {
    const previous = chatsRef.current

    setChats(current => getGretaAIChatChatsWithoutId(current, id))

    try {
      await deleteAIConversation({ id })

      return true
    } catch (reason) {
      if (isApiNotFoundStatus(reason?.response?.status)) {
        return true
      }

      setChats(previous)

      return false
    }
  }

  return { addChat, dropChat, removeChat, renameChat }
}
